import Mock from "mockjs";

export default {
  getData: config => {
    const { parentId } = JSON.parse(config.body);
    const data = {};
    data.data = {
      orderQuantitySum: 41,
      purchaseAmountSum: 123456789.03,
      rows: []
    };
    let obj = {};
    if (parentId === -1) {
      obj = Mock.mock({
        "rows|8-10": [
          {
            sonRows: [],
            orderType: "",
            orgType: 110,
            orgName: "中国交通建设集团有限公司",
            orderDate: "2020-8-3",
            prefecture: "工程专区",
            commodity: "安全帽",
            orderQuantity: 11,
            purchaseAmount: 123456789012.52,
            "orgId|+1": 2
          }
        ]
      });
    } else {
      obj = Mock.mock({
        "rows|2-5": [
          {
            sonRows: [],
            orderType: "",
            orgType: 110,
            orderDate: "2020-8-3",
            prefecture: "工程专区",
            commodity: "安全帽",
            orgName: "中国交通建设集团有限公司",
            orderQuantity: 11,
            purchaseAmount: 0,
            "orgId|20-1000": 0
          }
        ]
      });
    }

    data.data.rows = obj.rows;
    data.code = "0";
    data.message = "成功";
    return data;
  }
};
